angular.module('nv.routes.main').config(modalsConfigBlock);

function modalsConfigBlock($stateProvider) {
  // TODO: these appear not to be used any more
  $stateProvider
    .state('main.modals', {
      url: '/modal',
      abstract: true,
      views: {
        'modal-shell': {},
      },
      controller: 'ModalShellController',
      controllerAs: 'modalShellCtrl',
    })
    .state('main.modals.shareTool', {
      url: '/share',
    });
}
